// extracted by mini-css-extract-plugin
module.exports = {"documentType":"styles_documentType__1PCBH","orderRows":"styles_orderRows__3tOV8"};